import { render, staticRenderFns } from "./scenic_item.vue?vue&type=template&id=5c8f9205&scoped=true&"
import script from "./scenic_item.vue?vue&type=script&lang=ts&"
export * from "./scenic_item.vue?vue&type=script&lang=ts&"
import style0 from "./scenic_item.vue?vue&type=style&index=0&id=5c8f9205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f9205",
  null
  
)

export default component.exports